import * as React from 'react';

const SvgBurger = props => (
  <svg
    height={20}
    viewBox="0 0 34.448 20"
    width={34.448}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      data-name="Component 15 \u2013 1"
      id="Component_15_1"
      transform="translate(2 2)"
    >
      <line
        data-name="Line 53"
        fill="none"
        id="Line_53"
        strokeLinecap="round"
        strokeWidth={4}
        x2={30.448}
      />
      <line
        data-name="Line 54"
        fill="none"
        id="Line_54"
        strokeLinecap="round"
        strokeWidth={4}
        transform="translate(0 8)"
        x2={30.448}
      />
      <line
        data-name="Line 55"
        fill="none"
        id="Line_55"
        strokeLinecap="round"
        strokeWidth={4}
        transform="translate(0 16)"
        x2={30.448}
      />
    </g>
  </svg>
);

export default SvgBurger;

